import { CommandProcessor } from '@/api/CommandProcessor'
import { store } from '@/store'
import * as uuid from 'uuid'
import { BOT_DOMAIN, DOMAIN } from '../settings'
import { AppSettings } from '@/appSettings'

export class MessageCommandProcessor {
  static getMessages(identity, messageId?, storageDate?) {
    const to = AppSettings.get('SEND_THREADS_COMMANDS_TO_APPLICATION') === 'true' ?
      `postmaster@threads.${DOMAIN}` : undefined
    if (storageDate && messageId) {
      return CommandProcessor.processCommand({
        method: 'get',
        to,
        uri: `/threads/${encodeURI(
          `${identity}@${BOT_DOMAIN}`,
        )}?messageId=${messageId}&storageDate=${storageDate}&$take=20&direction=desc&refreshExpiredMedia=true`,
      })
    }
    else if (messageId) {
      return CommandProcessor.processCommand({
        method: 'get',
        to,
        uri: `/threads/${encodeURI(
          `${identity}@${BOT_DOMAIN}`,
        )}?messageId=${messageId}&$take=20&direction=desc&refreshExpiredMedia=true`,
      })
    } else {
      return CommandProcessor.processCommand({
        method: 'get',
        to,
        uri: `/threads/${encodeURI(
          `${identity}@${BOT_DOMAIN}`,
        )}?$take=20&direction=desc&refreshExpiredMedia=true`,
      })
    }
  }

  static send(
    customMessageMetadata: object,
    { content, type, metadata },
    sendId = true,
  ) {
    const storeClient = store.getters.instance
    if (customMessageMetadata) {
      metadata = { ...metadata, ...customMessageMetadata }
    }
    const message = {
      id: sendId ? uuid.v4() : undefined,
      to: `${store.getters.botIdentity}@${BOT_DOMAIN}`,
      type,
      content,
      metadata,
      status: undefined,
    }
    storeClient.sendMessage(message)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/api/MessageCommandProcessor.ts